module.exports = __webpack_public_path__ + "img/play.51828632.svg";